export default __webpack_public_path__ + "static/media/compatible-magento.d53f9811.svg";